import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from '@/components/ui/sonner';
import { Phone, CalendarDays } from 'lucide-react';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pb-16 lg:pb-0">{children}</main>
      <Footer />
      <Toaster position="bottom-right" />

      {/* Sticky Mobile CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white border-t border-slate-200 shadow-lg">
        <div className="flex">
          <a
            href="https://taxproanswers.setmore.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-sticky-book"
            className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-brand-green text-white text-sm font-semibold"
          >
            <CalendarDays className="w-4 h-4" />
            Book Free Consultation
          </a>
          <a
            href="tel:+18555892461"
            data-testid="mobile-sticky-call"
            className="flex items-center justify-center gap-2 px-5 py-3.5 bg-brand-navy text-white text-sm font-semibold"
          >
            <Phone className="w-4 h-4" />
            Call
          </a>
        </div>
      </div>
    </div>
  );
}
